/* ============================================================
   PHOTO MAGNET UPLOAD - JavaScript
   Uses Cropper.js + ImgBB (free image hosting)
   
   FLOW:
   1. Customer uploads & crops photo
   2. Cropped image uploads to ImgBB (free, instant)
   3. ImgBB returns a URL like https://i.ibb.co/xxxxx.jpg
   4. URL is stored in Shopify cart line item property
   5. Store owner sees clickable image links in orders
   
   SETUP: Get free API key at https://api.imgbb.com/
   Replace YOUR_IMGBB_API_KEY below with your key.
   ============================================================ */

(function () {
  'use strict';

  var CONFIG = {
    maxImageDimension: 1200,
    jpegQuality: 0.85,
    aspectRatio: 1,
    // ⚠️ REPLACE THIS with your free ImgBB API key
    // Get one at: https://api.imgbb.com/ (sign up → get key)
    imgbbApiKey: '600efc37f9a2ac750e8e274b94747950'
  };

  var state = {
    selectedVariantId: null,
    requiredQty: 1,
    images: [],
    cropper: null,
    activeSlotIndex: null
  };

  var app = document.getElementById('photo-magnet-app');
  if (!app) return;

  var uploadGrid = document.getElementById('pm-upload-grid');
  var addToCartBtn = document.getElementById('pm-add-to-cart');
  var modalOverlay = document.getElementById('pm-modal-overlay');
  var modalClose = document.getElementById('pm-modal-close');
  var modalUpload = document.getElementById('pm-modal-upload');
  var cropImage = document.getElementById('pm-crop-image');
  var rotationSlider = document.getElementById('pm-rotation-slider');
  var zoomSlider = document.getElementById('pm-zoom-slider');
  var priceDisplay = document.getElementById('pm-price');

  function init() {
    var firstBtn = document.querySelector('.pm-qty-btn');
    if (firstBtn) {
      state.selectedVariantId = firstBtn.dataset.variantId;
      state.requiredQty = parseQty(firstBtn.dataset.qty);
    }

    document.querySelectorAll('.pm-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { selectVariant(btn); });
    });

    modalClose.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', function (e) {
      if (e.target === modalOverlay) closeModal();
    });
    modalUpload.addEventListener('click', applyCrop);

    document.querySelectorAll('.pm-tool-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { handleTool(btn.dataset.action); });
    });

    rotationSlider.addEventListener('input', function () {
      if (state.cropper) state.cropper.rotateTo(parseFloat(rotationSlider.value));
    });

    zoomSlider.addEventListener('input', function () {
      if (state.cropper) state.cropper.zoomTo(parseFloat(zoomSlider.value));
    });

    addToCartBtn.addEventListener('click', addToCart);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    renderSlots();
  }

  function parseQty(title) {
    var match = title.match(/(\d+)/);
    return match ? parseInt(match[1]) : 1;
  }

  function selectVariant(btn) {
    document.querySelectorAll('.pm-qty-btn').forEach(function (b) {
      b.classList.remove('pm-qty-active');
    });
    btn.classList.add('pm-qty-active');
    state.selectedVariantId = btn.dataset.variantId;
    state.requiredQty = parseQty(btn.dataset.qty);
    if (priceDisplay && btn.dataset.price) {
      priceDisplay.textContent = btn.dataset.price;
    }
    state.images = [];
    renderSlots();
    updateCartButton();
  }

  function renderSlots() {
    uploadGrid.innerHTML = '';
    for (var i = 0; i < state.requiredQty; i++) {
      var slot = document.createElement('div');
      slot.className = 'pm-upload-slot';
      slot.dataset.slotIndex = i;

      var existingImage = state.images.find(function (img) { return img.slotIndex === i; });

      if (existingImage) {
        slot.classList.add('pm-has-image');
        slot.innerHTML =
          '<img class="pm-slot-preview" src="' + existingImage.dataUrl + '" alt="Photo ' + (i + 1) + '" width="140" height="140">' +
          '<button class="pm-slot-remove" data-slot="' + i + '" title="Remove" aria-label="Remove photo">' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
          '</button>' +
          '<div class="pm-slot-edit-overlay"><span class="pm-slot-edit-text">Tap to edit</span></div>';

        (function (idx) {
          slot.addEventListener('click', function (e) {
            if (e.target.closest('.pm-slot-remove')) return;
            openFileDialog(idx);
          });
          var removeBtn = slot.querySelector('.pm-slot-remove');
          removeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            state.images = state.images.filter(function (img) { return img.slotIndex !== idx; });
            renderSlots();
            updateCartButton();
          });
        })(i);

      } else {
        slot.innerHTML =
          '<svg class="pm-slot-icon" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
          '<path d="M12 5v14M5 12h14"/></svg>' +
          '<span class="pm-slot-label">Tap Here To<br>Upload Your Photos</span>' +
          '<span class="pm-slot-counter">' + state.images.length + '/' + state.requiredQty + '</span>';

        (function (idx) {
          slot.addEventListener('click', function () { openFileDialog(idx); });
        })(i);
      }

      uploadGrid.appendChild(slot);
    }
  }

  function openFileDialog(slotIndex) {
    state.activeSlotIndex = slotIndex;
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = function (e) {
      var file = e.target.files[0];
      if (file) openEditor(file);
    };
    input.click();
  }

  function openEditor(file) {
    var reader = new FileReader();
    reader.onload = function (e) {
      if (state.cropper) {
        state.cropper.destroy();
        state.cropper = null;
      }

      cropImage.src = e.target.result;
      modalOverlay.classList.add('pm-modal-open');
      document.body.style.overflow = 'hidden';
      rotationSlider.value = 0;
      zoomSlider.value = 1;

      cropImage.onload = function () {
        if (typeof Cropper === 'undefined') {
          alert('Image editor is still loading. Please try again in a moment.');
          closeModal();
          return;
        }
        state.cropper = new Cropper(cropImage, {
          aspectRatio: CONFIG.aspectRatio,
          viewMode: 1,
          dragMode: 'move',
          autoCropArea: 0.9,
          restore: false,
          guides: true,
          center: true,
          highlight: false,
          cropBoxMovable: true,
          cropBoxResizable: true,
          toggleDragModeOnDblclick: false,
          background: true,
          responsive: true,
          ready: function () {
            var imageData = state.cropper.getImageData();
            zoomSlider.value = imageData.width / imageData.naturalWidth;
          }
        });
      };
    };
    reader.readAsDataURL(file);
  }

  function closeModal() {
    modalOverlay.classList.remove('pm-modal-open');
    document.body.style.overflow = '';
    if (state.cropper) {
      state.cropper.destroy();
      state.cropper = null;
    }
  }

  function handleTool(action) {
    if (!state.cropper) return;
    switch (action) {
      case 'rotateLeft':
        state.cropper.rotate(-90);
        break;
      case 'flipH':
        var sx = state.cropper.getData().scaleX || 1;
        state.cropper.scaleX(-sx);
        break;
      case 'flipV':
        var sy = state.cropper.getData().scaleY || 1;
        state.cropper.scaleY(-sy);
        break;
      case 'aspectRatio':
        var cur = state.cropper.options.aspectRatio;
        state.cropper.setAspectRatio(cur === 1 ? NaN : 1);
        break;
    }
  }

  function applyCrop() {
    if (!state.cropper) return;
    var canvas = state.cropper.getCroppedCanvas({
      maxWidth: CONFIG.maxImageDimension,
      maxHeight: CONFIG.maxImageDimension,
      imageSmoothingEnabled: true,
      imageSmoothingQuality: 'high'
    });
    if (!canvas) return;

    var dataUrl = canvas.toDataURL('image/jpeg', CONFIG.jpegQuality);
    var idx = state.images.findIndex(function (img) {
      return img.slotIndex === state.activeSlotIndex;
    });

    if (idx >= 0) {
      state.images[idx].dataUrl = dataUrl;
    } else {
      state.images.push({ slotIndex: state.activeSlotIndex, dataUrl: dataUrl });
    }

    closeModal();
    renderSlots();
    updateCartButton();
  }

  function updateCartButton() {
    addToCartBtn.disabled = state.images.length < state.requiredQty;
  }

  /* ============================================================
     IMGBB UPLOAD
     Uploads base64 image to ImgBB and returns the URL
     ============================================================ */
  function uploadToImgBB(base64Data, name) {
    return new Promise(function (resolve, reject) {
      // Strip the data:image/jpeg;base64, prefix
      var pure = base64Data.split(',')[1];

      var formData = new FormData();
      formData.append('key', CONFIG.imgbbApiKey);
      formData.append('image', pure);
      formData.append('name', name || 'magnet_photo');

      fetch('https://api.imgbb.com/1/upload', {
        method: 'POST',
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.success) {
            resolve(data.data.url);
          } else {
            reject(new Error('ImgBB upload failed: ' + JSON.stringify(data)));
          }
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }

  async function addToCart() {
    if (state.images.length < state.requiredQty) return;

    var cartText = addToCartBtn.querySelector('.pm-cart-text');
    var cartLoading = addToCartBtn.querySelector('.pm-cart-loading');
    cartText.style.display = 'none';
    cartLoading.style.display = 'flex';
    addToCartBtn.disabled = true;

    try {
      var sorted = state.images.slice().sort(function (a, b) { return a.slotIndex - b.slotIndex; });

      // Save to sessionStorage for cart preview
      try {
        var previewStore = sorted.map(function (img, i) {
          return { name: 'Photo ' + (i + 1), data: img.dataUrl };
        });
        sessionStorage.setItem('pm_images', JSON.stringify(previewStore));
      } catch (e) {}

      // Upload each image to ImgBB and collect URLs
      var properties = {};
      for (var i = 0; i < sorted.length; i++) {
        var url = await uploadToImgBB(
          sorted[i].dataUrl,
          'magnet_photo_' + (i + 1) + '_' + Date.now()
        );
        // Shopify renders properties ending in _url as clickable links!
        properties['Photo ' + (i + 1)] = url;
      }

      // Add to cart with just the URLs (tiny payload, no Cloudflare issues)
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(state.selectedVariantId),
          quantity: 1,
          properties: properties
        })
      });

      if (!res.ok) {
        var errText = await res.text();
        console.error('[PM] Cart error:', res.status, errText);
        throw new Error(errText);
      }

      window.location.href = '/cart';

    } catch (err) {
      console.error('[PM] Error:', err);
      alert('Error: ' + err.message);
    } finally {
      cartText.style.display = '';
      cartLoading.style.display = 'none';
      addToCartBtn.disabled = false;
    }
  }

  init();
})();
